import { GroupEdit } from "./GroupEdit";
import { GroupCreate } from "./GroupCreate";
import GroupWorkOutlinedIcon from "@material-ui/icons/GroupWorkOutlined";
import { GroupsList } from "./GroupsList";

export default {
  icon: GroupWorkOutlinedIcon,
  list: GroupsList,
  create: GroupCreate,
  edit: GroupEdit,
};
